import { Box, Button, Container, Grid, Link, List, ListItem, ListItemText, Typography, Menu, MenuItem } from '@material-ui/core';
import { useInputStyles } from '../../../shared/components/UploadStyles';
import React, { useState } from 'react';
import { HomeContext } from '../../Home/HomeContext';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { AuthContext } from '../../Authentication/AuthContext';
import FAQ from '../../../assets/Clients/Ambev/faq.pdf';
import InfluencerWelcomeMessage from '../components/InfluencerWelcomeMessage';
export default function InfluencerICEHomeItens() {
    const classes = useInputStyles();
    const homeContext = React.useContext(HomeContext);
    const authContext = React.useContext(AuthContext);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="80vh"
            padding={5}
        >
            <Grid
                direction="column"
                justifyContent="center"
                alignItems="center"
            >
                <InfluencerWelcomeMessage />
                <Grid container justifyContent="center" alignContent='center' direction='row' spacing={3}>
                    {(authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Submissão Influenciadores') != undefined
                        &&
                        authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Submissão Influenciadores') >= 0)
                        && (
                            <Grid item xs>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    fullWidth
                                    aria-controls="solicitar-analise-menu"
                                    aria-haspopup="true"
                                    onClick={event => setAnchorEl(event.currentTarget)}
                                >
                                    <Box height={30} width={240} fontSize="small">
                                        <div className={classes.alignItemTextCenter}>
                                            Solicitar análise
                                        </div>
                                    </Box>
                                </Button>
                                <Menu
                                    id="solicitar-analise-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={() => setAnchorEl(null)}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    PaperProps={{
                                        style: {
                                            minWidth: 310,
                                        },
                                    }}
                                >
                                    <MenuItem onClick={() => { setAnchorEl(null); homeContext.setPageLocation(PageLocation.INFLUENCER_SINGLE_PROFILE_SUBMIT); }}>
                                        Influenciadores
                                    </MenuItem>
                                    <MenuItem onClick={() => { setAnchorEl(null); homeContext.setPageLocation(PageLocation.INFLUENCER_SINGLE_CAMPAIGN_SUBMIT); }}>
                                        Campanhas e projetos
                                    </MenuItem>
                                    <MenuItem onClick={() => { setAnchorEl(null); homeContext.setPageLocation(PageLocation.INFLUENCER_SINGLE_COMPANY_SUBMIT); }}>
                                        Empresas, eventos e patrocínios
                                    </MenuItem>
                                </Menu>
                            </Grid>
                        )}
                    {(authContext.login.user.profile?.functionalities.findIndex(
                        f => f.description == 'Acesso ao Dash Influencers ICE') != undefined
                        &&
                        authContext.login.user.profile?.functionalities.findIndex(
                            f => f.description == 'Acesso ao Dash Influencers ICE') >= 0)
                        && (
                            <Grid item xs>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    fullWidth
                                    onClick={() => homeContext.setPageLocation(PageLocation.DASHBOARD_INFLUENCER_BOTICARIO)}>
                                    <Box height={30} width={240}>
                                        <div className={classes.alignItemTextCenter}>
                                            Dashboard
                                        </div>
                                    </Box>
                                </Button>
                            </Grid>
                        )}
                    {(authContext.login.user.profile?.functionalities.findIndex(
                        f => f.description == 'Acesso Submissão Influenciadores' ||
                            f.description == 'Acesso Classificação Influenciadores'
                    ) != undefined
                        &&
                        authContext.login.user.profile?.functionalities.findIndex(
                            f => f.description == 'Acesso Submissão Influenciadores' ||
                                f.description == 'Acesso Classificação Influenciadores'
                        ) >= 0)

                        && (
                            <Grid item xs>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    fullWidth>
                                    <Box height={30} width={240}>
                                        <div className={classes.alignItemTextCenter}
                                            onClick={() => {
                                                const link = document.createElement('a');
                                                link.href = FAQ;
                                                link.target = '_blank';
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                            }}
                                        >
                                            FAQ
                                        </div>
                                    </Box>
                                </Button>
                            </Grid>
                        )}
                </Grid>
            </Grid>
        </Box>
    );
}
// imports já estão no topo do arquivo
// Removed duplicate import of useState